<template>
  <div class="HeaderSquares">
    <inline-svg
      v-if="topSquare"
      :src="require('@/assets/poetix-logo-other-half.svg')"
      class="HeaderSquares__top"
    />
    <inline-svg
      v-if="bottomSquare"
      :src="require('@/assets/poetix-logo-other-half.svg')"
      class="HeaderSquares__bottom"
    />
  </div>
</template>

<script>
export default {
  props: {
    topSquare: {
      type   : Boolean,
      default: false,
    },
    bottomSquare: {
      type   : Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.HeaderSquares {
  &__top {
    position: absolute;
    right: -33.812em;
    height: 20em;
    top: -7.5em;

    @include media-breakpoint-only(md) {
      top: -9.8125em;
      right: -39.6875em;
      height: 25em;
    }

    @include media-breakpoint-only(lg) {
      right: -58.78em;
      top: -15.625em;
      height: 37em;
    }
    @include media-breakpoint-up(xl) {
      top: -19.4em;
      right: -71.5em;
      height: 45em;
    }
  }

  &__bottom {
    position: absolute;
    display: none;

    @include media-breakpoint-up(lg) {
      display: unset;
      height: 37em;
      right: -41em;
      top: 1.5em;
    }

    @include media-breakpoint-up(xl) {
      height: 45em;
      right: -49.437em;
    }
  }
}
</style>
